import React from 'react';
import { Alert } from '@mui/material';
import { WifiOff as WifiOffIcon } from '@mui/icons-material';
import { useError } from '../contexts/ErrorContext';

export default function OfflineBanner() {
  const { isOffline } = useError();

  if (!isOffline) return null;

  return (
    <Alert
      severity="warning"
      icon={<WifiOffIcon />}
      sx={{ borderRadius: 0 }}
    >
      Keine Internetverbindung — einige Funktionen sind nicht verfügbar.
    </Alert>
  );
}
